<template>
<div class="categorized-faq section" id="faq">

<div class="container px-4 py-5">


    <section aria-labelledby="academic-section-label">    <!--cat-->

         <div class="row justify-content-center" data-aos="fade" data-aos-duration="500" data-aos-once="true" data-aos-offset="50">
           <div class="col-md-8">
               <div class="header mb-4">
              <h2 id="academic-section-label">Academic</h2>
              </div>

         <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                    Are CSU Global Direct courses transferable?
                </button>
                </h3>
                <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">Yes, CSU Global Direct courses are accredited through the Higher Learning Commission. We recommend that you also check with your selected institution regarding the transfer credit.</div>
                </div>
            </div><!--end accordion item-->

            <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingTwo">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                    Is it possible to only take a 1-credit lab without taking the entire course?
                </button>
                </h3>
                <div id="flush-collapseTwo" class="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">No. At this time, all labs are integrated into the course, which makes them four-credit courses. Three-credit courses do not include a lab.</div>
                </div>
            </div><!--end accordion item-->

            <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingThree">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                    Are there proctored exams?
                  </button>
                </h3>
                <div id="flush-collapseThree" class="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">No, CSU Global Direct courses do not utilize proctoring.</div>
                </div>
              </div><!--end accordion item-->


              <div class="accordion-item">
                <h3 class="accordion-header" id="flush-headingFive">
                  <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFive" aria-expanded="false" aria-controls="flush-collapseFive">
                    How do I get a copy of my transcript?
                  </button>
                </h3>
                <div id="flush-collapseFive" class="accordion-collapse collapse" aria-labelledby="flush-headingFive" data-bs-parent="#accordionFlushExample">
                  <div class="accordion-body">CSU Global has partnered with Parchment to provide a secure and efficient official credential service for paper and electronic transcripts. Instead of uploading a form to request your official transcript,simply click the "Order Official Transcript" button on the front page of the CSU Global Direct <a href="https://portal.csuglobal.edu/">student portal</a>. After you complete the ordering process, Parchment and CSU Global will take care of the rest! If you have questions about ordering your official transcript, please contact the Office of the Registrar <a href="mailto:registrar@csuglobal.edu">registrar@csuglobal.edu</a>.</div>
                </div>
              </div><!--end accordion item-->

            

            
            </div><!--end accordion-->


           </div><!--end accordion col-->
         </div><!--end row-->
         </section><!--end cat-->

             <section class="" aria-labelledby="admissions-section-label">    <!--cat-->


         
 
         <div class="row justify-content-center" data-aos="fade" data-aos-duration="500" data-aos-once="true" data-aos-offset="50">
           <div class="col-md-8">

              <div class="header mb-4">    
              <h2 id="admissions-section-label">Admissions</h2>
              </div>
               <div class="accordion accordion-flush" id="accordionCostExample">


                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingSix">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSix" aria-expanded="false" aria-controls="flush-collapseSix">
                            When do CSU Global Direct classes begin?
                        </button>
                        </h3>
                        <div id="flush-collapseSix" class="accordion-collapse collapse" aria-labelledby="flush-headingSix" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Our flexible <router-link to="/calendar">Academic Calendar</router-link> aligns with the CSU Global academic calendar, which means we have classes starting at regular intervals throughout the year. <router-link to="/get-started#register">Enroll now</router-link> to start classes next term.
                        </div>
                        </div>
                    </div><!--end accordion item-->



                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingEight">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEight" aria-expanded="false" aria-controls="flush-collapseEight">
                            How do I enroll in a CSU Global Direct course?
                        </button>
                        </h3>
                        <div id="flush-collapseEight" class="accordion-collapse collapse" aria-labelledby="flush-headingEight" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Registration to CSU Global Direct is simple and quick! Because there are no admissions requirements or fees, you can complete the process in as little as 15 minutes. To register, follow these easy steps: visit the self-serve enrollment portal, select your courses, and submit your payment. <router-link to="/get-started#register">Click here to register now</router-link>.</div>
                        </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingNine">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNine" aria-expanded="false" aria-controls="flush-collapseNine">
                            Do I need to send my transcripts to CSU Global to register for CSU Global Direct courses?
                        </button>
                        </h3>
                        <div id="flush-collapseNine" class="accordion-collapse collapse" aria-labelledby="flush-headingNine" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">No. These courses are non-degree seeking. Once you register and pay for your course(s), you are ready to start.</div>
                        </div>
                    </div><!--end accordion item-->

                    
                </div><!--end accordion-->


           </div><!--end accordion col-->
         </div><!--end row-->
        </section><!--end cat-->


      <section aria-labelledby="cost-section-label">    <!--cat-->

         <div class="row justify-content-center" data-aos="fade" data-aos-duration="500" data-aos-once="true" data-aos-offset="50">
           <div class="col-md-8">
             
            <div class="header mb-4">   
            <h2 id="cost-section-label">Cost</h2>
            </div>

               <div class="accordion accordion-flush" id="accordionAdmissionsExample">

                 <div class="accordion-item">
                    <h3 class="accordion-header" id="flush-headingTen">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTen" aria-expanded="false" aria-controls="flush-collapseTen">
                        Is Federal Financial Aid available for CSU Global Direct courses?
                    </button>
                    </h3>
                    <div id="flush-collapseTen" class="accordion-collapse collapse" aria-labelledby="flush-headingTen" data-bs-parent="#accordionFlushExample">
                    <div class="accordion-body">No, Federal Financial Aid (Pell Grants, Federal Subsidized Loan, Federal Direct Unsubsidized Loan, Parent Plus Loan, Grad Plus Loan) is not available for students who take courses through CSU Global Direct. These courses are not eligible for any Federal Financial Aid as they are independent courses that do not lead to a degree from CSU Global.</div>
                    </div>
                  </div><!--end accordion item-->

                  

                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingEleven">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEleven" aria-expanded="false" aria-controls="flush-collapseEleven">
                            Can I use a 529 Plan for courses in CSU Global Direct?
                        </button>
                        </h3>
                        <div id="flush-collapseEleven" class="accordion-collapse collapse" aria-labelledby="flush-headingEleven" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Yes, may use their 529 to cover eligible educational expenses, including tuition and books. Please refer to your plan provider's distribution rules and regulations to ensure you meet eligibility requirements. A student will be required to pay for their courses at the time of registration, and any subsequent 529 Plan payment that is received by the school will be applied to the student's account, with excess funding being reimbursed to the student through their original method of payment.</div>
                        </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingTwelve">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwelve" aria-expanded="false" aria-controls="flush-collapseTwelve">
                            Can students use Military Assistance/GI Bill to pay for courses?
                        </button>
                        </h3>
                        <div id="flush-collapseTwelve" class="accordion-collapse collapse" aria-labelledby="flush-headingTwelve" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Students using Active Duty Tuition Assistance benefits and Veterans administration chapter benefits are ineligible to use their benefits with CSU Global Direct courses as students must be enrolled in a degree or certificate program to be eligible.</div>
                        </div>
                    </div><!--end accordion item-->


                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingThirteem">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThirteem" aria-expanded="false" aria-controls="flush-collapseThirteem">
                            Are payment plans available for CSU Global Direct courses?
                        </button>
                        </h3>
                        <div id="flush-collapseThirteem" class="accordion-collapse collapse" aria-labelledby="flush-headingThirteem" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Due to the accelerated, non-degree seeking nature of these courses, payment plans are not available for CSU Global Direct courses.</div>
                        </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingFourteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFourteen" aria-expanded="false" aria-controls="flush-collapseFourteen">
                            Are there alternative payment options available?
                        </button>
                        </h3>
                        <div id="flush-collapseFourteen" class="accordion-collapse collapse" aria-labelledby="flush-headingFourteen" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Yes, since CSU Global Direct courses are not eligible for Federal Financial Aid or a traditional payment plan, there are alternative private student loan options for a non-degree seeking student through a bank/lender. We encourage students to do extensive research to determine if an alternative private student loan is the right fit for them. Please note that an alternative private student loan must be in the student's name, but can include a co-signer if required by the lender. Make sure that the private student loan that you are applying for is for a Non-Degree Seeking Alternative Private Student Loan. If you choose a private alternative student loan and have been approved through a lender's online application, the CSU Global Financial Aid office will need to certify the loan and work with a CSU Global Direct Enrollment Counselor to register you for your course.</div>
                        </div>
                    </div><!--end accordion item-->



                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingFifteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseFifteen" aria-expanded="false" aria-controls="flush-collapseFifteen">
                            When using an Alternative Private Student Loan, can I borrow more than the cost of tuition and fees?
                        </button>
                        </h3>
                        <div id="flush-collapseFifteen" class="accordion-collapse collapse" aria-labelledby="flush-headingFifteen" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">No, CSU Global will only certify an Alternative Private Student Loan for the cost of tuition and fees for the courses listed on the lender's application.</div>
                        </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                        <h3 class="accordion-header" id="flush-headingSixteeen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSixteeen" aria-expanded="false" aria-controls="flush-collapseSixteeen">
                            Can I make changes to the Alternative Private Student Loan Request Form?
                        </button>
                        </h3>
                        <div id="flush-collapseSixteeen" class="accordion-collapse collapse" aria-labelledby="flush-headingSixteeen" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">We understand that course planning, pairing, and sequencing are important. Changes can be made to an Alternative Private Student Loan certification prior to when courses start for the term. Once the course starts, no changes can be made to the certification of the loan.  If changes need to be made to courses prior to the start of classes, please contact our Financial Aid Advising team with any questions via email: <a href="">financialaid@csuglobal.edu</a> or phone: <a href="">855-212-6700</a>.</div>
                        </div>
                    </div><!--end accordion item-->

  


                    <div class="accordion-item">
                      <h3 class="accordion-header" id="flush-headingSeventeen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseSeventeen" aria-expanded="false" aria-controls="flush-collapseSeventeen">
                          Can I use tuition reimbursement from my employer?
                        </button>
                      </h3>
                      <div id="flush-collapseSeventeen" class="accordion-collapse collapse" aria-labelledby="flush-headingSeventeen" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Please refer to your employer's tuition reimbursement policy in regards to non-degree seeking courses. A student will be required to pay upfront and register for courses. If the student receives any tuition reimbursement and it is received by the university, the student will be reimbursed any credit amount on their student account.</div>
                      </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                      <h3 class="accordion-header" id="flush-headingEighteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseEighteen" aria-expanded="false" aria-controls="flush-collapseEighteen">
                          What is the refund policy?
                        </button>
                      </h3>
                      <div id="flush-collapseEighteen" class="accordion-collapse collapse" aria-labelledby="flush-headingEighteen" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Student who choose to drop their course are eligible for a refund of their tuition through the first week of the term.
                            <ul><li>100% if the course is dropped on or before the seventh day (census date) </li>
                            <li>$0 after first week</li></ul></div>
                      </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                      <h3 class="accordion-header" id="flush-headingNineteen">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseNineteen" aria-expanded="false" aria-controls="flush-collapseNineteen">
                          Will I receive a Form 1098-T for these courses?
                        </button>
                      </h3>
                      <div id="flush-collapseNineteen" class="accordion-collapse collapse" aria-labelledby="flush-headingNineteen" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">Yes.</div>
                      </div>
                    </div><!--end accordion item-->

                    <div class="accordion-item">
                      <h3 class="accordion-header" id="flush-headingTwenty">
                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwenty" aria-expanded="false" aria-controls="flush-collapseTwenty">
                          How much do CSU Global Direct courses cost?
                        </button>
                      </h3>
                      <div id="flush-collapseTwenty" class="accordion-collapse collapse" aria-labelledby="flush-headingTwenty" data-bs-parent="#accordionFlushExample">
                        <div class="accordion-body">As a not-for-profit public university, our goal is to make your education affordable and attainable. The tuition rate is $350 per undergraduate credit hour. There are no additional student fees or out-of-state premiums at CSU Global, so your tuition, lab costs, and materials are the only things you’ll pay.</div>
                      </div>
                    </div><!--end accordion item-->

                    

                  </div><!--end accordion--><!--end cat-->


           </div><!--end accordion col-->
         </div><!--end row-->
         </section><!--end cat-->


        </div><!--end container-->
    </div><!--end section-->

</template>

<script>
export default {
  name: 'CategorizedFAQ',
  props: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.accordion-button:not(.collapsed) {
  color:#000;
  background-color:#eee;
}

.accordion-body {
  margin-left:2rem;
}

.accordion-button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='black'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
}

.accordion-button:focus {
  box-shadow:none;
}

.header {
    margin-top:5rem;
}

</style>
